<div
  [attr.role]="toast.config.type === state.promptType ? 'dialog' : 'alert'"
  [attr.aria-labelledby]="'notification_'+toast.id"
  [attr.aria-modal]="toast.config.type === state.promptType"
  [ngClass]="[
  'notificationToast animated',
   'notification-' + toast.config.type,
    state.animation,
    toast.valid === undefined ? '' : (toast.valid ? 'notificationToast--valid' : 'notificationToast--invalid')
  ]"
  [ngStyle]="{
  '-webkit-transition': toast.config.animation.time + 'ms',
  transition: toast.config.animation.time + 'ms',
  '-webkit-animation-duration': toast.config.animation.time + 'ms',
  'animation-duration': toast.config.animation.time + 'ms'
  }"
  (animationend)="onExitTransitionEnd()"
  (click)="onClick()"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <div
    class="notificationToast__progressBar"
    *ngIf="toast.config.showProgressBar">
    <span
      class="notificationToast__progressBar__percentage"
      [ngStyle]="{'width': (state.progress * 100) + '%'}"></span>
  </div>
  <div
    class="notificationToast__inner"
    *ngIf="!toast.config.html; else toastHTML">
    <div
      class="notificationToast__title"
      [attr.id]="'notification_'+toast.id"
      *ngIf="toast.title">
      {{toast.title | truncate : toast.config.titleMaxLength}}
    </div>
    <div
      class="notificationToast__body"
      *ngIf="toast.body">
      {{toast.body | truncate : toast.config.bodyMaxLength}}
    </div>
    <xm-notification-prompt
      *ngIf="toast.config.type === state.promptType"
      [toast]="toast">
    </xm-notification-prompt>
    <div
      *ngIf="!toast.config.icon; else elseBlock"
      [ngClass]="['notification-icon', (toast.config.iconClass || 'notification-icon--' + toast.config.type)]"></div>
    <ng-template #elseBlock>
      <img
        class="notification-icon"
        [src]='toast.config.icon'>
    </ng-template>
  </div>
  <ng-template #toastHTML>
    <div
      class="notificationToast__inner"
      [innerHTML]="toast.config.html"></div>
  </ng-template>
  <xm-notification-button
    *ngIf="toast.config.buttons"
    [toast]="toast"></xm-notification-button>
</div>
